// =============================================================================
// DATA / RENTALS-VANCOUVER.JS — Event rental & décor companies (Vancouver & Sea-to-Sky)
// Simple format: { name, ig, igLink, url, link, phone?, email?, note? }
// =============================================================================

export const vancouverRentalData = [
  {
    name: "Bespoke Décor",
    ig: "@bespokedecor",
    igLink: "https://www.instagram.com/bespokedecor/",
    url: "bespokedecor.ca",
    link: "https://bespokedecor.ca",
    email: "hello@bespokedecor.ca",
  },
  {
    name: "Pedersen's Event Rentals",
    ig: "@pedersenseventrentals",
    igLink: "https://www.instagram.com/pedersenseventrentals/",
    url: "pedersens.com",
    link: "https://pedersens.com",
    email: "sales@vancouver.pedersens.com",
  },
  {
    name: "Ellssi Events",
    ig: "@ellssievents",
    igLink: "https://www.instagram.com/ellssievents/",
    url: "ellssi.com",
    link: "https://www.ellssi.com",
    email: "info@ellssi.com",
    note: "Full décor rental, design, and day-of coordination. Also offers custom builds, faux florals, and stationery.",
  },
  {
    name: "Lux Affairs",
    ig: "@luxaffairs",
    igLink: "https://www.instagram.com/luxaffairs/",
    url: "luxaffairs.com",
    link: "https://luxaffairs.com",
    email: "info@luxaffairs.com",
    phone: "604-813-7272",
    note: "Full-service event production firm — planning, design, décor, and rentals all in one.",
  },
  {
    name: "The Reverie Co.",
    ig: "@thereverieco",
    igLink: "https://www.instagram.com/thereverieco/",
    url: "thereverieco.com",
    link: "https://thereverieco.com",
    email: "hello@thereverieco.com",
    note: "Whistler-based.",
  },
  {
    name: "Event Rental Works",
    ig: "@eventrentalworks",
    igLink: "https://www.instagram.com/eventrentalworks/",
    url: "eventrentalworks.com",
    link: "https://eventrentalworks.com",
    email: "info@eventrentalworks.com",
    note: "Pemberton-based — ideal for Sea-to-Sky weddings.",
  },
  {
    name: "Blacksheep Event Rentals",
    ig: "@blacksheepeventrentals",
    igLink: "https://www.instagram.com/blacksheepeventrentals/",
    url: "blacksheeprentals.ca",
    link: "https://www.blacksheeprentals.ca",
    email: "sales@blacksheeprentals.ca",
    note: "Squamish-based non-profit; exclusive rental partner at Fergie's Sunwolf. Proceeds support BC heritage railway preservation.",
  },
];
